<template>
  <div class="auditListPage" v-if="applicantData.workflowCode">
    <p class="tit">审批记录</p>
    <van-steps direction="vertical" :active="auditActive">
      <van-step class="fristList">
        <h3>
          {{
            applyMsg.applicantIdName
              ? applyMsg.applicantIdName
              : applyMsg.applicantName
              ? applyMsg.applicantName
              : applyMsg.realName
          }}
        </h3>
        <p>发起</p>
      </van-step>
      <van-step v-for="(item, index) in auditList" :key="index">
        <dl class="itemList">
          <dt>
            <!-- <img
              :src="`${
                item.avatar ? item.avatar : baseUrl + 'userDefault.png'
              }`"
              alt
              srcset
            /> -->
            <van-image
              round
              fit="cover"
              :src="`${
                item.avatar ? item.avatar : baseUrl + 'userDefault.png'
              }`"
            />
          </dt>
          <dd class="spName">
            <span
              v-if="item.buttonCode == 'cancel' || item.buttonCode == 'retry'"
              >{{ item.realName }}&nbsp;&nbsp;<em>{{
                item.currentNodeName
              }}</em></span
            >
            <span v-else
              >{{ item.operatorName }}&nbsp;&nbsp;<em>{{
                item.currentNodeName
              }}</em></span
            >
          </dd>
          <dd class="spTime">{{ item.createTime }}</dd>
          <dd class="spMsg">
            {{ item.message }}
            <span class="signatureImg">
              <img :src="`${item.signatureImg}`" />
            </span>
          </dd>
          <dd
            :class="[
              'sanjiao',
              item.buttonCodeName == '拒绝' ? '' : 'sureStyle',
            ]"
            v-if="item.buttonCode == 'pass' || item.buttonCode == 'reject'"
          >
            {{ item.buttonCodeName }}
          </dd>
        </dl>
      </van-step>
      <van-step
        v-if="
          applyMsg.verifyStatus == 'pending' || applyMsg.verifyStatus == 'doing'
        "
      >
        <h3 class="pending">等待审批</h3>
      </van-step>
      <van-step v-if="applyMsg.verifyStatus == 'pass'" class="lastList">
        <h3 class="pending">结束</h3>
      </van-step>
    </van-steps>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      keyWord: "",
      applyMsg: {},
      auditList: [],
      auditActive: 0,
    };
  },
  props: {
    applicantData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.applicantData && this.applicantData.workflowCode) {
        this.applyMsg = this.applicantData;
        this.keyWord = this.applicantData.workflowCode;
        this.getAuditHistoryList();
      }
    });
  },
  methods: {
    getAuditHistoryList() {
      let _this = this;
      _this.$api.flowPath.flow
        .getAuditHistoryList(_this.keyWord)
        .then((res) => {
          if (res.code == "1") {
            _this.auditList = res.data.reverse();
            _this.auditList.forEach((item) => {
              item.createTime = item.createTime.substring(5);
            });
            _this.auditActive = _this.auditList.length;
            if (this.applyMsg.verifyStatus == "pass") {
              _this.auditActive = _this.auditList.length + 1;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    applicantData: {
      handler: function (val) {
        if (val && val.workflowCode) {
          this.applyMsg = newApi.assign({}, this.applyMsg, val);
          this.keyWord = val.workflowCode;
          this.getAuditHistoryList();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.auditListPage {
  width: 100%;
  background-color: #fff;
  padding-top: 8px;
  .tit {
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
  }
  .tit:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 21px;
    background: #2581d6;
    top: 12px;
    left: 16px;
  }
  .fristList.van-step,
  .lastList.van-step {
    .van-step__title {
      color: #3c78fa !important;
    }
    .van-step__circle,
    .van-step__line {
      background-color: #3c78fa !important;
    }
  }
  .van-hairline::after {
    content: none;
  }
  .van-step {
    color: #333;
    h3.pending {
      font-weight: 400;
    }
    .van-step__circle-container {
      font-size: 18px;
      i {
        color: #3c78fa !important;
      }
      .van-step__circle {
        width: 10px;
        height: 10px;
        background-color: #3c78fa !important;
      }
    }
    .van-step__line {
      background-color: #3c78fa !important;
    }
    // .van-step--finish .van-step__circle, .van-step--finish .van-step__line{
    //   background-color: #3c78fa!important;
    // }
    // .van-step--finish .van-step__circle, .van-step--finish .van-step__line{
    //    background-color: #3c78fa!important;
    // }
  }

  .itemList {
    background-color: #fafafa;
    padding: 8px 8px;
    position: relative;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    min-height: 90px;
    padding-left: 65px;
    dt {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      position: absolute;
      top: 5px;
      left: 5px;
      img {
        width: 50px;
        height: 50px;
        display: block;
      }
    }
    dd {
      top: 12px;
      font-size: 14px;
      color: #666;
    }
    dd.spName {
      font-weight: bold;
      color: #333;
      em {
        font-weight: normal;
        color: #666;
      }
    }
    dd.spTime {
      position: absolute;
      top: 12px;
      right: 12px;
    }
    dd.spMsg {
      display: block;
      position: relative;
      z-index: 2;
      .signatureImg {
        width: 100px;
        height: 45px;
        display: block;
        margin: 5px 0 8px 0;
        opacity: 0.8;
        z-index: 1;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    dd.sanjiao {
      width: 65px;
      height: 45px;
      line-height: 45px;
      transform: rotate(-40deg);
      -webkit-transform: rotate(-40deg);
      position: absolute;
      top: 23px;
      right: 5%;
      color: red;
      font-size: 14px;
      text-align: center;
      border: 1px solid red;
      opacity: 0.5;
    }
    dd.sanjiao.sureStyle {
      color: #4cbc84;
      border: 1px solid #4cbc84;
    }
  }
}
</style>